module.exports = __webpack_public_path__ + "static/media/viewmoretriangleicon.52722a61.svg";